import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private static readonly DARK_CLASS = 'ion-palette-dark';
  private static readonly THEME_KEY = 'dev-theme';

  readonly isDark = signal(false);

  constructor() {
    this.initTheme();
    
    const observer = new MutationObserver(() => {
      this.isDark.set(ThemeService.checkDark());
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  private initTheme() {
    const stored = localStorage.getItem(ThemeService.THEME_KEY);
    let shouldBeDark = false;
    
    if (stored === 'dark' || stored === 'light') {
      shouldBeDark = stored === 'dark';
    } else {
      shouldBeDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    
    this.isDark.set(shouldBeDark);
    this.applyTheme(shouldBeDark);
  }

  toggleTheme() {
    this.setTheme(!this.isDark());
  }

  setTheme(isDark: boolean) {
    this.isDark.set(isDark);
    localStorage.setItem(ThemeService.THEME_KEY, isDark ? 'dark' : 'light');
    this.applyTheme(isDark);
  }

  private applyTheme(isDark: boolean) {
    document.documentElement.classList.toggle(ThemeService.DARK_CLASS, isDark);
  }

  private static checkDark(): boolean {
    return document.documentElement.classList.contains(ThemeService.DARK_CLASS);
  }
}
